import React, { Component } from "react";
import { Redirect } from "react-router-dom";

class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: "",
      success: null,
      redirect: false,
    };
  }
  clearInputs = () =>
    document
      .querySelectorAll('input:not([type="submit"])')
      .forEach((val) => (val.value = ""));
  handleSubmit = (e) => {
    e.preventDefault();
    // get token from local storage
    const token = this.props.token;
    fetch(
      this.props.url +
        (this.props.isLunda
          ? "/api/lundarundan/payment/code"
          : "/api/payment/code"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: e.target.code.value,
          token: token,
        }),
      }
    )
      .then((res) => res.json())
      .then((json) => {
        this.setState({ ...this.state, ...json });
        this.clearInputs();
      });

    //e.target.code.value
    // Post req to backend
  };

  render() {
    return (
      <div className="loginComponent">
        {this.state.redirect && <Redirect to={this.state.redirect} />}
        {this.state.error && <p>{this.state.error}</p>}
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <div className="form">
            <div className="text-input" id="abId0.12727693608323598">
              <input type="text" placeholder="Kod" name="code" />
            </div>
          </div>
          <input type="submit" value="Använd kod" />
        </form>
      </div>
    );
  }
}

export default LoginComponent;
